<div class="custom-row">

  @if(mode==="read" && leadStatus !== approvedStatus && !readOnly){
  @if(isSectionEditable) {
  <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
    (click)="editInfo()"></ppl-button>
  }
  <!-- <span
    (click)="editInfo()"
    nz-icon
    nzType="edit"
    nzTheme="outline"
  ></span> -->
  }
</div>
@if(mode==="edit" ){
  <form nz-form [formGroup]="servicesForm" class="ppl-p0">
    <nz-form-item class="ppl-form-item">
      <nz-form-label nzSpan="4" [nzXs]="24" nzFor="servicesRendered"
        class="ppl-form-label">{{getAttributes('servicesRendered').label}}
        @if(getAttributes('servicesRendered').mandatory === 'Y'){
        <span>*</span>
        }</nz-form-label>
      <nz-form-control nzSpan="8" [nzXs]="24">
        <div [ngClass]="{'error': validationErrors['servicesRendered'] }">
          <ppl-multiselect formControlName="servicesRendered" id="servicesRendered" [options]="services"
            style="width:100%; margin-bottom: 16px" [showClear]="true"
            placeholder="{{getAttributes('servicesRendered').placeholder}}" [optionLabel]="'lkpValueName'"
            [optionValue]="'lkpValueCode'" [disabled]="false" [maxTagCount]="4" style="width:100%; margin-bottom: 16px"
            (ngModelChange)="onServicesRenderedChange($event)">
          </ppl-multiselect>
        </div>
        @if (validationErrors['servicesRendered']) {
        <span class="pl-1 error-message">{{validationErrors['servicesRendered']}}</span>
        }
      </nz-form-control>
    </nz-form-item>
    @if(showOtherTypeDesc && isAttrAvailable('otherTypeDesc')){
    <nz-form-item class="ppl-form-item">
      <nz-form-label nzSpan="4" [nzXs]="24" nzFor="otherTypeDesc"
        class="ppl-form-label">{{getAttributes('otherTypeDesc').label}}
        @if(getAttributes('otherTypeDesc').mandatory === 'Y'){
        <span>*</span>
        }</nz-form-label>
      <nz-form-control nzSpan="8" [nzXs]="24">
        <div [ngClass]="{'error': validationErrors['otherTypeDesc'] }">
          <input nz-input formControlName="otherTypeDesc" id="otherTypeDesc"
            placeholder="{{getAttributes('otherTypeDesc').placeholder}}"
            [ngClass]="{'error': validationErrors['maiden_name'] }" />
        </div>
        @if (validationErrors['otherTypeDesc']) {
        <span class="pl-1 error-message">{{validationErrors['otherTypeDesc']}}</span>
        }
      </nz-form-control>
    </nz-form-item>
    }
  </form>
  <div class="custom-row">
    <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
      (click)="cancelEdit()"></ppl-button>

    <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
      (click)="save()"></ppl-button>
  </div>
}
@else if(mode==="read" && secData){
  @if(filledInfo){
    <div nz-row>
      <div nz-col nzSpan="4" class="ppl-read-label">{{getAttributes('servicesRendered')?.label}}</div>
      <div nz-col>
        {{lookupTransformed}}
      </div>
    </div>
  @if(showOtherTypeDesc && isAttrAvailable('otherTypeDesc')) {
    <div nz-row>
      <div nz-col nzSpan="4" class="ppl-read-label">{{getAttributes('otherTypeDesc')?.label}}</div>
      <div nz-col>
        {{otherTypeDescValue}}
      </div>
    </div>
  }
  }@else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
  }
}